module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7c6f2c04b962b68adfcc0e2368e3ff38.png";